// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat

import addDays from "date-fns/add_days";
import startOfDay from "date-fns/start_of_day";

export function isTodayTz(dateTz, offset) {
  const now = nowTz(offset);

  return (
    now.getDate() === dateTz.getDate() &&
    now.getMonth() === dateTz.getMonth() &&
    now.getFullYear() === dateTz.getFullYear()
  );
}

export function isTomorrowTz(dateTz, offset) {
  const now = nowTz(offset);
  const tomorrow = addDays(startOfDay(now), 1);

  return (
    tomorrow.getDate() === dateTz.getDate() &&
    tomorrow.getMonth() === dateTz.getMonth() &&
    tomorrow.getFullYear() === dateTz.getFullYear()
  );
}

export function nowTz(offset) {
  return utcToTz(localToUtc(new Date(Date.now())), offset);
}

export function utcToTz(dateUtc, offset) {
  const ms = dateUtc.getTime() + hToMs(offset);

  const dateTz = new Date();
  dateTz.setTime(ms);

  return dateTz;
}

export function localToUtc(date) {
  // Hack
  // Consider local `date` as UTC,
  // and remove the local tz offset from it.
  // Note: Bangkok offset is +7, but `getTimezoneOffset` will return -7.
  return utcToTz(date, date.getTimezoneOffset() / 60);
}

// Helpers
function hToMs(h) {
  return h * 60 * 60 * 1000;
}
